<template>
  <div class="card mb-3">
    <div class="card-header text-white bg-secondary">
      Shipping Details
      <div class="header-button float-right">
        <button type="button" class="btn btn-warning btn-sm" @click="edit">
          {{ editButtonTxt }}
        </button>
        <!-- <button
          type="button"
          class="btn btn-info btn-sm"
          @click="showDetails = !showDetails"
        >
          More info
        </button> -->
      </div>
    </div>
    <div class="row" v-if="editMode">
      <div class="col-12">
        <form
          @submit.prevent="updateShipping"
          style="padding:15px;"
          :class="{ 'edit-highlight': editHighlight }"
        >
          <div class="row">
            <div class="col-4">
              <div class="form-group">
                <label for="company">Company</label>
                <input
                  type="text"
                  v-model="shipping_address.company"
                  class="form-control"
                  id="company"
                  aria-describedby="company_help"
                  placeholder="Company"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label for="address1">Address Line 1</label>
                <input
                  :class="{
                    'is-invalid':
                      $v.shipping_address.address1.$invalid && submit,
                    'is-valid': !$v.shipping_address.address1.$invalid && submit
                  }"
                  type="text"
                  v-model="shipping_address.address1"
                  class="form-control"
                  id="address1"
                  aria-describedby="address1_help"
                  placeholder="Address line 1"
                />
                <div
                  class="invalid-feedback"
                  v-if="!$v.shipping_address.address1.required"
                >
                  Please provide a Address line 1
                </div>
                <div
                  class="invalid-feedback"
                  v-if="!$v.shipping_address.address1.maxLength"
                >
                  Max allowed characters (35)
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="address2">Address Line 2</label>
                <input
                  :class="{
                    'is-invalid':
                      $v.shipping_address.address2.$invalid && submit,
                    'is-valid': !$v.shipping_address.address2.$invalid && submit
                  }"
                  type="text"
                  v-model="shipping_address.address2"
                  class="form-control"
                  id="address2"
                  aria-describedby="address2_help"
                  placeholder="Address line 2"
                />
                <div
                  class="invalid-feedback"
                  v-if="!$v.shipping_address.address2.maxLength"
                >
                  Max allowed characters (35)
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-4">
              <div class="form-group">
                <label for="city">City</label>
                <input
                  :class="{
                    'is-invalid': $v.shipping_address.city.$invalid && submit,
                    'is-valid': !$v.shipping_address.city.$invalid && submit
                  }"
                  type="text"
                  v-model="shipping_address.city"
                  class="form-control"
                  id="city"
                  aria-describedby="city_help"
                  placeholder="City"
                />
                <div
                  class="invalid-feedback"
                  v-if="!$v.shipping_address.city.required"
                >
                  Please provide a city
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label for="phone">Phone</label>
                <input
                  type="text"
                  v-model="shipping_address.phone"
                  class="form-control"
                  id="phone"
                  aria-describedby="phone_help"
                  placeholder="Phone"
                />
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label for="zip">Zip</label>
                <input
                  :class="{
                    'is-invalid': $v.shipping_address.zip.$invalid && submit,
                    'is-valid': !$v.shipping_address.zip.$invalid && submit
                  }"
                  type="text"
                  v-model="shipping_address.zip"
                  class="form-control"
                  id="zip"
                  aria-describedby="zip_help"
                  placeholder="Zip"
                />
                <div
                  class="invalid-feedback"
                  v-if="!$v.shipping_address.zip.required"
                >
                  Please provide a zip code
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <!-- <div class="col-4">
              <div class="form-group">
                <label for="shipping_method">Shipping Method</label>
                <input
                  :class="{
                    'is-invalid': $v.shipping_method.$invalid && submit,
                    'is-valid': !$v.shipping_method.$invalid && submit
                  }"
                  type="text"
                  v-model="shipping_method"
                  class="form-control"
                  id="shipping_method"
                  aria-describedby="shipping_method_help"
                  placeholder="Shipping Method"
                />
                <div class="invalid-feedback">
                  Please provide a shipping method
                </div>
              </div>
            </div> -->
          </div>

          <button type="submit" class="btn btn-success">Submit</button>
        </form>
      </div>
    </div>

    <table class="table table-striped" v-if="!editMode">
      <tbody>
        <!-- <tr>
          <td>Method</td>
          <td>{{ shipping_method }}</td>
        </tr> -->
        <tr>
          <td>
            <p class="shipping_address_line">
              {{ shipping_address.first_name }},
              {{ shipping_address.last_name }}
            </p>
            <p class="shipping_address_line">{{ shipping_address.company }}</p>
            <p class="shipping_address_line">{{ shipping_address.address1 }}</p>
            <p class="shipping_address_line">{{ shipping_address.address2 }}</p>
            <p class="shipping_address_line">
              {{ shipping_address.city }}, {{ shipping_address.province }}
            </p>
            <p class="shipping_address_line">
              {{ shipping_address.country }}
            </p>
            <p class="shipping_address_line">
              {{ shipping_address.zip }}, {{ shipping_address.phone }}
            </p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { required, numeric, maxLength } from "vuelidate/lib/validators";
export default {
  name: "shipping-details",
  props: ["order"],
  data() {
    return {
      showDetails: false,
      editMode: false,
      editButtonTxt: "Edit",
      submit: false,
      // shipping_method: "",
      shipping_address: {
        first_name: "",
        last_name: "",
        phone: "",
        zip: "",
        address1: "",
        address2: "",
        city: "",
        province: "",
        company: ""
      },
      editHighlight: false
    };
  },
  mounted() {
    // this.shipping_method = this.order.shipping_method;
    this.shipping_address = this.order.shipping_address;
  },
  validations: {
    // shipping_method: {
    //   required
    // },
    shipping_address: {
      first_name: {
        required
      },
      last_name: {
        required
      },
      zip: {
        required
      },
      city: {
        required
      },
      address1: {
        required,
        maxLength: maxLength(35)
      },
      address2: {
        maxLength: maxLength(35)
      }
    }
  },
  methods: {
    edit() {
      this.editMode = !this.editMode;
      this.editButtonTxt = this.editMode ? "Cancel" : "Edit";
      this.highlightEdit();
    },
    highlightEdit() {
      this.editHighlight = true;
      setTimeout(
        function() {
          this.editHighlight = false;
        }.bind(this),
        500
      );
    },
    updateShipping() {
      this.submit = true;
      if (!this.$v.$invalid) {
        //show loader
        let loader = this.$loading.show();
        let formData = {
          // shipping_method: this.shipping_method,
          shipping_address: this.shipping_address
        };

        this.$http
          .post(this.APIURL + this.BRAND + "/update-order", {
            orderID: this.order.id,
            data: formData
          })
          .then(
            () => {
              // this.$parent.order.shipping_method = this.shipping_method;
              this.$parent.order.shipping_address = this.shipping_address;
              this.editMode = false;
              this.editButtonTxt = "Edit";
              this.submit = false;
              loader.hide();
            },
            error => {
              console.log(error);
            }
          );
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.shipping_address_line {
  margin: 0px;
}
</style>
